export default class MediaQueries {

    public static mediaBreakpoints = {
        'xs': '(max-width: 575px)',
        'sm': '(min-width: 600px) and (max-width: 960px)',
        'md': '(min-width: 960px) and (max-width: 1024px)',
        'lg': '(min-width: 1024px) and (max-width: 1199px)',
        'xl': '(min-width: 1200px)' 
    }

    public static querySelect(): string {
        for (let value in this.mediaBreakpoints) {
            if (window.matchMedia(this.mediaBreakpoints[value]).matches) {
                return value;
            }
        }
    }

    public static matcheQuery(parmas) {
        const mql: MediaQueryList = window.matchMedia(this.mediaBreakpoints[parmas]);
        return mql;
    }

}


// WEBPACK FOOTER //
// ./src/app/util/media-queries-helper.ts